<template>
  <div
    class="dui-slim-progress-bar"
    :class="[ vm.colorClass ]"
  >
    <span
      class="progress"
      :style="{ 'width': value + '%' }"
    />
  </div>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';

export default {
  mixins: [
    coloredComponent,
  ],
  props: {
    value: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 100;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

@mixin makeColorProgressBar($color,
                            $color-variation,
                            $bg-color: getColor($white, base)) {

  background-color: $bg-color;

  .progress {
    background-color: getColor($color, $color-variation);
  }
}

.dui-slim-progress-bar {
  border-radius: $_0-5em;
  display: flex;
  height: $_1em;
  overflow: hidden;
  position: relative;

  .progress,
  .progress-label-and-value {
    position: absolute;
    z-index: 1;
  }

  .progress {
    border-radius: $_0-5em;
    height: 100%;
    left: 0;

    @include transition((
      width
    ), $transition-time-slow);
  }

  @include makeColorProgressBar($yellow, base);
  &.color-black  { @include makeColorProgressBar($black, base); }
  &.color-blue   { @include makeColorProgressBar($blue, base); }
  &.color-grey   { @include makeColorProgressBar($grey, base); }
  &.color-red    { @include makeColorProgressBar($red, base); }
  &.color-sand   { @include makeColorProgressBar($sand, base); }
  &.color-white  { @include makeColorProgressBar($white, base, transparent); }
  &.color-yellow { @include makeColorProgressBar($yellow, base); }
  &.color-yellow-grey-bg { @include makeColorProgressBar($yellow, base, getColor($grey, fade)); }
}
</style>
